import React, { Component } from "react";
import PropTypes from "prop-types";
import { withTranslation, Trans } from "react-i18next";
import swal from "sweetalert";
import SwipeableViews from "react-swipeable-views";
import {
  withStyles,
  makeStyles,
  useTheme,
  withTheme,
} from "@material-ui/core/styles";
import Popover from "@material-ui/core/Popover";
import AppBar from "@material-ui/core/AppBar";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import Typography from "@material-ui/core/Typography";
import Box from "@material-ui/core/Box";
import Grid from "@material-ui/core/Grid";
import Button from "@material-ui/core/Button";
import BusinessIcon from "@material-ui/icons/Business";
import RoomIcon from "@material-ui/icons/Room";
import Slider from "@material-ui/core/Slider";
import CheckIcon from "@material-ui/icons/Check";
import CloseIcon from "@material-ui/icons/Close";
import Fab from '@material-ui/core/Fab';
import FilterListIcon from '@material-ui/icons/FilterList';
import ListAltIcon from '@material-ui/icons/ListAlt';
import MapIcon from '@material-ui/icons/Map';
import PeopleIcon from '@material-ui/icons/People';
import ContactsIcon from '@material-ui/icons/Contacts';
import Accessrating from "./Accessrating.js";
import Getaccesssettings from "./Getaccesssettings";
import Getaccesssources from "./Getaccesssources";
import Map from "./Map";
import MapmarList from "./MapmarList";
import GooglemarkerList from "./GooglemarkerList";
import Maplistviewpagen from "./maplistviewpagen";
import { connect } from "react-redux";
import Services from "../../api/api";
import Loader from "../loaders/loader";
import { TextareaAutosize } from "@material-ui/core";
import maplistviewpagen from "./maplistviewpagen";

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`full-width-tabpanel-${index}`}
      aria-labelledby={`full-width-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box p={3}>
          <Typography component={"div"}>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};

function a11yProps(index) {
  return {
    id: `full-width-tab-${index}`,
    "aria-controls": `full-width-tabpanel-${index}`,
  };
}

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.background.paper,
  },
}));

class FullWidthTabs extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoading: true,
      value: 0,
      markerList: [],
      markerType: [],
      markerText: "imonitor",
      position: [],
      lat: -17.895114303749143,
      lng: 38.41781616210938,
      zoom: 2,
      tabList: [],
      mapcounter: 0,
    };
    this.handleChange = this.handleChange.bind(this);
    this.handleChangeIndex = this.handleChangeIndex.bind(this);
  }

  componentDidMount() {
    this.getTablist();
    this.getCurrentLocation();
    //this.getNearMelist()
    this.getNearMeTypes();
    this.triggerOnResume()
    //this.getStateListForNearme();
  }

  getTablist() {
    var menuList = JSON.parse(localStorage.getItem("menuList"));
    var tab = menuList.filter(obj => obj.path == 'nearme');
    if (tab.length > 0) {
      var tblist = tab[0].childs.filter(obj => obj.isactive && obj.visible);
      console.log(tblist)
      if (tblist.filter(obj => obj.path == "contact").length == 0) {
        tblist.unshift({
          componentId: 101,
          icon: "",
          isactive: true,
          label: "contact",
          name: "contact",
          path: "contact",
          show: "label",
          visible: true,
        })
      }
      this.setState({
        tabList: tblist,
      });
    }
  }

  triggerOnResume() {
    var that = this;
    if (window.cordova) {
      document.addEventListener("deviceready", function () {
        document.addEventListener("resume", function () {
          console.log('GPS on resume')
          setTimeout(function(){ that.getCurrentLocation(); }, 1500);         
        }, false);
      }, false);
    }
  }

  getCurrentLocation() {
    var that = this;
    var options = {
      enableHighAccuracy: true,
      timeout: 5000,
      maximumAge: 0,
    };

    //console.log(this.mapRef);

    let counter = this.state.mapcounter+1;
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        function (position) {
          console.log('position:', position);
          let arr = [position.coords.latitude, position.coords.longitude];
          that.setState({
            mapcounter: counter,
            lat: position.coords.latitude,
            lng: position.coords.longitude,
            isLoading: false,
            zoom: 13,
          });
          that.setState({ position: arr });
          that.getNearMelist();
        },
        that.locationerror(),
        options
      );
    } else {
      that.getNearMelist();
      //that.setState({ position: [] });
    }
  }

  locationerror() {
    console.log('location error')
    this.getNearMelist();
    if (window.cordova) {
      window.cordova.dialogGPS()
    } else {
      // swal({
      //   text: "Geolocation is not enabled. Please enable to use this feature",
      //   icon: "warning",
      //   button: "setting",
      // }).then((val) => {
      //   window.open('https://support.google.com/chrome/answer/142065?hl=en','_BLANK')
      // });
    }
  }

  getNearMelist() {
    var param = {
      latitude: this.state.lat,
      longitude: this.state.lng,
      distance: 10000,
      tags: [],
      isactive: 1,
      languageId: this.props.langId,
      communityId: this.props.communityuid,
    };

    Services.searchnearme(param).then((res) => {
      try {
        if (res.data.data.length > 0) {
          this.setState({ markerList: res.data.data, isLoading: false, });
        } else {
          this.getGoogleNearMe();
        }
      } catch (err) {
        console.log("Error::", err);
        this.setState({
          isLoading: false
        })
        this.getGoogleNearMe();
      }
    }).catch((err) => {
      this.getGoogleNearMe();
    });
  }

  getGoogleNearMe() {
    var param = {
      apiKey: "AIzaSyAk4_RjGS0QBVi6Waj-f2Qd0bK3gxuL4FU",
      lat: this.state.lat,
      lng: this.state.lng,
      radius: 1000,
      keywords: "hospital", //googleTypes
    };
    Services.getGoogleNearme(param).then((data) => {
      this.setState({ markerList: data.data.results, markerText: "google", isLoading: false, });
    });
  }

  // getNearMelist() {
  //   var param = {
  //     "uuid": this.props.communityuid,
  //     "isactive": 1
  //   }
  //   Services.getallnearme(param).then(data => {
  //     if (data.data.length > 0) {
  //       this.setState({ markerList: data.data })
  //     }
  //   })
  // }

  getNearMeTypes() {
    var param = {
      communityId: this.props.communityuid,
      isactive: 1,
      languageId: this.props.langId,
      alltypes: false,
    };
    Services.getNearMeTypes(param).then((data) => {
      try {
        if (data.data.data.length > 0) {
          this.setState({ markerType: data.data.data });
        }
      } catch (err) {
        console.log("Error::", err);
      }
    });
  }

  // getStateListForNearme() {
  //   var param = { "communityId": this.props.communityuid, "languageId": this.props.communityuid }
  //   Services.getNearMeTypes(param).then((data) => {

  //   });
  // }

  handleChange = (event, newValue) => {
    this.setState({
      value: newValue,
    });
  };

  handleChangeIndex = (index) => {
    console.log(index)
    const { t } = this.props;
    if (!navigator.onLine && index == 1) {
      swal({
        title: t("You are currently offline."),
        icon: "error",
        button: "Ok",
      })
    } else {
      this.setState({
        value: index,
      });  
    }
  };

  render() {
    const { t } = this.props;
    const { classes, theme } = this.props;
    const { templateID } = this.props;
    let bgStyles = templateID == 2 ? { background: this.props.componentbgcolor } : {};
    return (
      <div className={classes.root + " nearmepage getknowledgeable_page"}>
        {
          templateID == 1 && (
            <div className="backgroundivholder">
              <div className="bgdiv1">
                <div class="welcometopcurve">
                  <svg data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1200 120" preserveAspectRatio="none">
                    <path d="M600,112.77C268.63,112.77,0,65.52,0,7.23V120H1200V7.23C1200,65.52,931.37,112.77,600,112.77Z" class="shape-fill"></path>
                  </svg>
                </div>
              </div>
              <div className="bgdiv2"></div>
            </div>
          )
        }
        <AppBar className="tabheader" position="static" style={bgStyles}>
          <Tabs
            value={this.state.value}
            onChange={this.handleChange}
            indicatorColor="primary"
            textColor="inherit"
            variant="fullWidth"
            aria-label="full width tabs example"
          >
            {
              this.state.tabList.length > 0 ? (
                this.state.tabList.map((tabListObj, index) => {
                  return (<Tab label={t(tabListObj.label)} {...a11yProps(index)} />)
                })
              ) : ('')
            }
          </Tabs>
        </AppBar>
        <SwipeableViews
          axis={theme.direction === "rtl" ? "x-reverse" : "x"}
          index={this.state.value}
          onChangeIndex={this.handleChangeIndex}
          className="infotabcontainer getaccesstabspage"
        >

          {this.state.tabList.length > 0 &&
            this.state.tabList.map((tabListObj, index) => {
              return (
                <TabPanel value={this.state.value} index={index} dir={theme.direction}>
                  {tabListObj.componentId == 23 || tabListObj.path == "map" ?
                    (<div className="nearmemapcontainer">
                      {this.state.isLoading ? (
                        <Loader isLoading={this.state.isLoading} />
                      ) : (
                        <>
                          {
                            templateID == 1 && (
                              <>
                                {
                                  this.state.tabList.filter(obj => obj.path == "list").length > 0 &&
                                  <Fab aria-label="add" onClick={() => this.handleChangeIndex(2)} className="maplistviewfloatbtn">
                                    <ListAltIcon />
                                  </Fab>
                                }
                                <Fab color="primary" aria-label="add" onClick={() => this.handleChangeIndex(0)} className="cantactfloatbtn">
                                  <ContactsIcon />
                                </Fab>
                              </>
                            )

                          }
                          <Map
                            key={this.state.mapcounter}
                            markerList={this.state.markerList}
                            markerType={this.state.markerType}
                            markerText={this.state.markerText}
                            componentbgcolor={this.props.componentbgcolor}
                            templateID={templateID}
                          ></Map>
                        </>
                      )
                      }

                    </div>) : (
                      tabListObj.componentId == 24 || tabListObj.path == "list" ? (
                        <div className="markerList">
                          {
                            templateID == 1 && (
                              <>
                                <Fab color="primary" aria-label="add" onClick={() => this.handleChangeIndex(1)} className="mapfilterfloatbtn">
                                  <MapIcon />
                                </Fab>
                                <Fab color="primary" aria-label="add" onClick={() => this.handleChangeIndex(0)} className="cantactfloatbtn">
                                  <ContactsIcon />
                                </Fab>
                              </>
                            )
                          }
                          {this.state.markerText == "imonitor" ? (
                            <MapmarList
                              userposition={this.state.position}
                              markerType={this.state.markerType}
                              markerList={this.state.markerList}
                              uuid={this.props.communityuid}
                            ></MapmarList>
                          ) : (
                            <GooglemarkerList
                              userposition={this.state.position}
                              markerList={this.state.markerList}
                              uuid={this.props.communityuid}
                            ></GooglemarkerList>
                          )}
                        </div>
                      ) : (
                        tabListObj.componentId == 101 || tabListObj.path == "contact" ? (
                          <div className="neameContactview">
                            {
                              templateID == 1 && (
                                <>
                                  <Fab color="primary" aria-label="add" onClick={() => this.handleChangeIndex(1)} className="mapfilterfloatbtn">
                                    <MapIcon />
                                  </Fab>
                                  {
                                    this.state.tabList.filter(obj => obj.path == "list").length > 0 &&
                                    <Fab aria-label="add" onClick={() => this.handleChangeIndex(2)} className="maplistviewfloatbtn">
                                      <ListAltIcon />
                                    </Fab>
                                  }
                                </>
                              )
                            }
                            <Maplistviewpagen></Maplistviewpagen>
                          </div>
                        ) : ('')
                      )
                    )
                  }
                </TabPanel>
              )
            })
          }

          {
            this.state.isLoading && (
              <TabPanel value={this.state.value} index={0} dir={theme.direction}> <div className="height500"><Loader isLoading={this.state.isLoading} /></div> </TabPanel>
            )
          }

        </SwipeableViews>
      </div>
    );
  }
}

FullWidthTabs.propTypes = {
  classes: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => {
  let { storeState } = state;
  return {
    templateID: JSON.parse(localStorage.getItem('templateID')) != null ? JSON.parse(localStorage.getItem('templateID')) : storeState.templateID,
    communityuid: storeState.communityId,
    langId: storeState.langId,
    componentbgcolor: storeState.componentbgcolor
  };
};


const transFullWidthTabs = withTranslation()(FullWidthTabs);
const ThemeFullWidthTabs = withTheme(transFullWidthTabs);
export default withStyles(useStyles)(
  connect(mapStateToProps)(ThemeFullWidthTabs)
);
